import * as consts from '../constants';
import * as commonActions from './commonActions';

// import networkApi from '../api/mocks/mockNetworkApi'
import networkApi from '../api/networkApi';
import userApi from '../api/userApi';

export function loadNetworksSuccess(pagingModel) {
    return { type: consts.ACTONS.LOAD_NETWORKS_SUCCESS, pagingModel };
}

export function loadNetworksFailed() {
    return { type: consts.ACTONS.LOAD_NETWORKS_FAILED };
}

export function loadNetworks(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworks(getState().authenticationState.token, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            res.name = pagingModel.name;
            res.vatCode = pagingModel.vatCode;
            res.dataInizioAttivita = pagingModel.dataInizioAttivita;
            res.dataFineAttivita = pagingModel.dataFineAttivita;
            dispatch(loadNetworksSuccess(res));
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadNetworksFailed());
            throw (error);
        });
    };
}

export function networksExport(pagingModel) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.networksExport(getState().authenticationState.token, pagingModel).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadAllNetworks() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadAllNetworks(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadNetworksFailed());
            throw (error);
        });
    };
}

export function loadAllWithProducts() {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadAllWithProducts(getState().authenticationState.token).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadNetworksFailed());
            throw (error);
        });
    };
}

export function loadNetwork(id) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetwork(getState().authenticationState.token, id).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function exportNetwork(nwetworkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.exportNetwork(getState().authenticationState.token, nwetworkId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveNetwork(network) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveNetwork(getState().authenticationState.token, network).then(savedNetwork => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadNetworks(getState().networkState));
            return savedNetwork;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveQuote(quote) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveQuote(getState().authenticationState.token, quote).then(savedNetwork => {
            dispatch(commonActions.unlockScreen());
            dispatch(loadNetworks(getState().networkState));
            return savedNetwork;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadLogo(networkId, file) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadLogo(getState().authenticationState.token, networkId, file).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function configurationFileUpLoad(networkId, file) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.configurationFileUpLoad(getState().authenticationState.token, networkId, file).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Notes 
// *******************************************************************************************************************
export function loadNotes(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNotes(getState().authenticationState.token, networkId).then(notes => {
            dispatch(commonActions.unlockScreen());
            return notes;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveNote(note) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveNote(getState().authenticationState.token, note).then(note => {
            dispatch(commonActions.unlockScreen());
            return note;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteNote(noteId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.deleteNote(getState().authenticationState.token, noteId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Referents 
// *******************************************************************************************************************
export function loadReferentNetworks(userId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadReferentNetworks(getState().authenticationState.token, userId).then(networkReferents => {
            dispatch(commonActions.unlockScreen());
            return networkReferents;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveNetworkReferent(networkReferent) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveNetworkReferent(getState().authenticationState.token, networkReferent).then(note => {
            dispatch(commonActions.unlockScreen());
            return networkReferent;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteNetworkReferent(networkReferentId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.deleteNetworkReferent(getState().authenticationState.token, networkReferentId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Masters 
// *******************************************************************************************************************
export function loadNetworkMasterUsers() {

    const pagingModel = {
        itemsPerPage: 1000,
        page: 1,
        roleId: consts.AUTHENTICATION.USER_ROLE.NetworkMaster,
        sortName: 'lastName',
        sortOrder: 'asc'
    };

    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return userApi.loadUsers(getState().authenticationState.token, pagingModel).then(res => {
            dispatch(commonActions.unlockScreen());
            return res;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadNetworkMastersByNetwork(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworkMastersByNetwork(getState().authenticationState.token, networkId).then(networkMasters => {
            dispatch(commonActions.unlockScreen());
            return networkMasters;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadNetworkMastersByUser(userId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworkMasters(getState().authenticationState.token, userId).then(networkMasters => {
            dispatch(commonActions.unlockScreen());
            return networkMasters;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveNetworkMaster(networkMaster) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveNetworkMaster(getState().authenticationState.token, networkMaster).then(note => {
            dispatch(commonActions.unlockScreen());
            return networkMaster;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteNetworkMaster(networkMasterId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.deleteNetworkMaster(getState().authenticationState.token, networkMasterId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Products 
// *******************************************************************************************************************
export function loadNetworkProducts(networkId, showClosed = true) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworkProducts(getState().authenticationState.token, networkId, showClosed).then(products => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadNetworkProduct(productId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworkProduct(getState().authenticationState.token, productId).then(products => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadNetworkProductsReady(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadNetworkProductsReady(getState().authenticationState.token, networkId).then(products => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function loadActiveNetworkProducts(networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.loadActiveNetworkProducts(getState().authenticationState.token, networkId).then(products => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function saveProduct(product) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.saveProduct(getState().authenticationState.token, product).then(product => {
            dispatch(commonActions.unlockScreen());
            return product;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function deleteProduct(productId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.deleteProduct(getState().authenticationState.token, productId).then(() => {
            dispatch(commonActions.unlockScreen());
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cloneProducts(networkFromId, networkToId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.cloneProducts(getState().authenticationState.token, networkFromId, networkToId).then((products) => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cloneProduct(productId, networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.cloneProduct(getState().authenticationState.token, productId, networkId).then((products) => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function cloneSomeProducts(productsIds, networkId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.cloneSomeProducts(getState().authenticationState.token, productsIds, networkId).then((products) => {
            dispatch(commonActions.unlockScreen());
            return products;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

// *******************************************************************************************************************
//                                                      Documents 
// *******************************************************************************************************************
export function eliminaDocumento(documentId) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.eliminaDocumento(getState().authenticationState.token, documentId).then((network) => {
            dispatch(commonActions.unlockScreen());
            return network;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}

export function caricaDocumento(networkId, file) {
    return function (dispatch, getState) {
        dispatch(commonActions.lockScreen());
        return networkApi.caricaDocumento(getState().authenticationState.token, networkId, file).then(contract => {
            dispatch(commonActions.unlockScreen());
            return contract;
        }).catch(error => {
            dispatch(commonActions.unlockScreen());
            throw (error);
        });
    };
}